module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Dead? Undead? Limbering Bastards")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1-today-now"
    }
  }, [_vm._v("Chapter 1: Today Now")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-2-a-few-days-ago-at-the-factory"
    }
  }, [_vm._v("Chapter 2: A Few Days Ago (at the Factory)")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-3-the-road-ahead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: The Road Ahead")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4-my-knight-in-shining-armour",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: My Knight in Shining Armour")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5-weakness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Weakness")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6-the-supermarket",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: The Supermarket")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7-nightmare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Nightmare")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8-over-the-wall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Over the Wall")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9-ed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Ed")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10-gerry-allen-and-the-girls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Gerry, Allen and the Girls")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11-rooftop-escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Rooftop Escape")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-12-past-the-shopping-mall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Past the Shopping Mall")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-13-the-golf-course",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: The Golf Course")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-14-my-neighbourhood",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: My Neighbourhood")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-15-here-and-now",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Here and Now")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0